import React, { FC } from "react";
import { Form, Modal, Spinner } from "react-bootstrap";
import new_project_img from "./img/new-project-img.png";
import { useTranslation } from "react-i18next";
import { Formik } from "formik";
import { newProjectSchema } from "./validation/newProjectSchema";
import { StyledInput } from "../../inputs/styledInput";
import { useDomainNewMutation } from "../../../graphql/projects.hooks";
import { UserDocument, useUserQuery } from "../../../graphql/menu.hooks";
import { FREE_LIMIT } from "../../../utils";
import { projectLimitModal } from "../../../graphql/state";
import { useNavigate } from "react-router-dom";
import useGetUrlLocale from "../../../hooks/useGetUrlLocale";

type Props = {
  showModal: boolean;
  closeModal: () => void;
};

export const CreateProjectModal: FC<Props> = ({ showModal, closeModal }) => {
  const { t } = useTranslation();
  const lng = useGetUrlLocale();
  const navigate = useNavigate();

  const [addNewDomain, { loading }] = useDomainNewMutation();
  const { data: userData } = useUserQuery();

  const isPremium = userData?.user.activePremium;

  const initialValues = {
    title: "",
  };

  const tryCreateProject = async (values: any) => {
    if (
      userData?.user.domains.length >= FREE_LIMIT.PROJECT &&
      !userData?.user.admin &&
      !isPremium
    ) {
      closeModal();
      projectLimitModal(true);
      return;
    }
    try {
      const { data } = await addNewDomain({
        variables: values,
        refetchQueries: [{ query: UserDocument }],
      });

      if (data?.domainNew) {
        navigate(`${lng}/projects`);
        closeModal();
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={closeModal}
      className="px-sm-2 px-md-0"
      size="lg"
      dialogClassName="create-project-content"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header
        closeButton
        className="border-0 pb-0 px-3 pt-3"
      ></Modal.Header>
      <Modal.Body className="px-3 px-md-4 d-flex flex-column align-items-center">
        <img
          className="mb-4"
          src={new_project_img}
          alt="girl with a computer"
        />
        <p className="text-dark fs-3 fw-bold mb-2 text-center">
          {t("modal.Create New Project")}
        </p>
        <p className="mb-3 fs-7 text-gray text-center">
          {t("modal.Create a new project to organize your pages")}
        </p>
        <Formik
          initialValues={initialValues}
          validationSchema={newProjectSchema(t)}
          onSubmit={tryCreateProject}
          enableReinitialize
        >
          {({ handleSubmit, touched, errors }) => (
            <Form className="col-12" onSubmit={handleSubmit}>
              <div className="form-floating mb-4">
                <StyledInput
                  name="title"
                  label={t("projects.Project Title")}
                  error={!!(touched.title && errors.title)}
                />
              </div>
              <button
                disabled={loading}
                type="submit"
                className="btn btn-primary col-12 py-3 mb-md-2 fw-bold fs-6 text-white"
              >
                {t("copyModal.create")}
                {loading && (
                  <Spinner
                    animation="border"
                    role="status"
                    size="sm"
                    className="ms-2"
                  />
                )}
              </button>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};
